import { render } from "./PrivacyPolicyView.vue?vue&type=template&id=6990b1ca"
import script from "./PrivacyPolicyView.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__